import type { CalendarEventData } from '../add-to-calendar';

export interface BookingCalendarEventInput {
  bookingId: string;
  appointmentTypeName: string;
  providerName: string;
  startTime: Date;
  endTime: Date;
  description: string;
  location?: string | null;
}

export function formatBookingCalendarTitle(
  appointmentTypeName: string,
  providerName: string,
): string {
  const provider = providerName.trim();
  return provider
    ? `${appointmentTypeName} with ${provider}`
    : appointmentTypeName;
}

// The single builder behind the confirmation screen, the client email and the
// .ics file, so the appointment a client saves never depends on where they clicked.
export function buildBookingCalendarEventData(
  input: BookingCalendarEventInput,
): CalendarEventData {
  return {
    uid: input.bookingId,
    title: formatBookingCalendarTitle(
      input.appointmentTypeName,
      input.providerName,
    ),
    description: input.description,
    startTime: input.startTime,
    endTime: input.endTime,
    location: input.location?.trim() || undefined,
  };
}
